/**
 * sw-pr-gw-customer-dashboard
 * SpendWyze Payment Request Gateway Customer Dashboard
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BillingReportTasks } from './billingReportTasks';

export interface BillingReport { 
    /**
     * The sum of the completed payment request tasks in the requested month
     */
    sum: number;
    tasks: Array<BillingReportTasks>;
}